interface SummaryItem {
  label: string;
  value: string;
  color?: 'default' | 'emerald' | 'red';
  icon: string;
  onClick?: () => void;
}

interface CustomerSummaryGridProps {
  items: SummaryItem[];
  className?: string;
}

export default function CustomerSummaryGrid({ items, className = '' }: CustomerSummaryGridProps) {
  const getValueColor = (color?: string) => {
    switch (color) {
      case 'emerald': return 'text-emerald-600';
      case 'red': return 'text-red-500';
      default: return 'text-foreground-900';
    }
  };

  return (
    <>
      {/* Desktop: 5-col grid */}
      <div className={`hidden lg:grid grid-cols-5 gap-4 ${className}`}>
        {items.map((item) => (
          <div
            key={item.label}
            className={`stat-card ${item.onClick ? 'cursor-pointer hover:bg-background-100 transition-colors' : ''}`}
            onClick={item.onClick}
          >
            <span className="text-xs font-medium text-foreground-400 uppercase tracking-wider">{item.label}</span>
            <p className={`text-xl font-bold mt-1 font-heading ${getValueColor(item.color)}`}>{item.value}</p>
          </div>
        ))}
      </div>

      {/* Mobile: 2-col compact grid */}
      <div className={`lg:hidden grid grid-cols-2 gap-2 ${className}`}>
        {items.map((item) => (
          <div
            key={item.label}
            className={`bg-background-50 rounded-xl border border-background-200/70 p-3 flex flex-col justify-center ${item.onClick ? 'cursor-pointer active:scale-[0.98] transition-transform' : ''}`}
            style={{ minHeight: 88 }}
            onClick={item.onClick}
          >
            <div className="flex items-center gap-1.5 mb-1">
              <i className={`${item.icon} text-xs text-foreground-400`}></i>
              <span className="text-[10px] font-medium text-foreground-400 uppercase tracking-wider">{item.label}</span>
            </div>
            <p className={`text-base font-bold font-heading truncate ${getValueColor(item.color)}`}>{item.value}</p>
          </div>
        ))}
      </div>
    </>
  );
}